"use client";

import { Autocomplete } from "@leabankab/component-library";
import { FormField } from "@leabankab/component-library/react-hook-form";
import { useConstantSelectOptions } from "@/features/customer-information/hooks/use-constant-options";

interface ConstantAutocompleteFieldProps {
	name: string;
	label: string;
	optionsKey: string;
	max?: number;
}

export const ConstantAutocompleteField = ({
	name,
	label,
	optionsKey,
	max,
}: ConstantAutocompleteFieldProps) => {
	const options = useConstantSelectOptions(optionsKey);

	return (
		<FormField
			name={name}
			render={({ field }) => (
				<Autocomplete
					label={label}
					options={options}
					multiple
					min={0}
					max={max}
					{...field}
					value={field.value ?? []}
				/>
			)}
		/>
	);
};
